module.exports = __webpack_public_path__ + "static/media/Aldo.11003cd7.svg";